import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({

  menu: {
    display: 'flex',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#fff',
    borderBottom: '2px solid #0000',
    '&:hover': {
      color: '#ff5a0f',
      borderColor: '#ff5a0f',
    },
    zIndex: 2,
    borderRadius: '8px',
    padding: '0px 10px',
    margin: '2px 0px',
  },
  menuItemContainer: {
    display: 'flex', 
    flexDirection: 'column',
    position: 'absolute',
    paddingTop: '25px',
    alignItems: 'left',
    transform: 'translateX(-10px)',
  },

  menuItem: {
    display: 'flex',
    justifyContent: 'start',
    fontSize: '14px',
    fontWeight: 'normal',
    color: '#fff',
    backgroundColor: '#000a',
    '&:hover': {
      color: '#ff5a0f',
    },
    zIndex: 3,
    borderRadius: '2px',
    padding: '2px 4px',
  }, 
  disabledItem: {
    display: 'flex',
    justifyContent: 'start',
    fontSize: '14px',
    fontWeight: 'normal',
    color: '#919191',
    backgroundColor: '#000a',
    zIndex: 3,
    borderRadius: '2px',
    padding: '2px 4px',
  },
  preTitle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '20px',
  },
  icon: {
    width: '18px',
    height: '18px',
    paddingRight: 2,
  },
  title: {
    textAlign: 'left',
  },
  shortcutText: {
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#a5a5a5',
    width: 'max-content',
    textAlign: 'right',
    marginLeft: 'auto',
    paddingLeft: '20px',
  },
}));

export default useStyles;